// extracted by mini-css-extract-plugin
export default {"products":"Ot-z","card":"Pt-z","oosMessaging":"Qt-z"};